/* fb-variants.js — Empire-free variant selector for the PDP.
   Empire's bundle defined the <variant-selection>/<options-selection> custom elements
   (@pixelunion/shopify-variants-ui). With Empire gated off on product pages this module
   takes over using the native <select name="id" data-variants> that the form already
   renders as the noscript fallback — UX-equivalent here because every multi-variant
   product in the catalog is single-option (GRAMAJE / Peso), so one dropdown IS the
   option picker. Single-variant products render a hidden input instead → no-op.
   On change: current price + compare-at update, ATC enabled state, ?variant= URL,
   gallery variant media, and a bubbling fb:variant-change event.
   No-op when Empire is on the page (its script tag carries data-scripts). */
(function () {
  'use strict';
  if (document.querySelector('script[data-scripts]')) return; // Empire owns variants here

  function money(c) {
    return '$ ' + (Math.round(c) / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-variant-selection]'), function (vs) {
      var sel = vs.querySelector('select[name="id"][data-variants]');
      if (!sel || sel.hasAttribute('data-fb-variants')) return;
      sel.setAttribute('data-fb-variants', '');

      // retire the Empire-driven per-option UI; surface the native select instead
      var opts = vs.querySelector('[data-options-selection]');
      if (opts) opts.remove();
      sel.style.display = '';
      sel.classList.add('fb-variants');

      // "elige una variante" placeholder → auto-pick the first available option
      // (mirrors the select_first_available_variant theme setting, which is ON)
      if (!sel.value || sel.value === 'not-selected') {
        for (var i = 0; i < sel.options.length; i++) {
          var o = sel.options[i];
          if (!o.disabled && o.value !== 'not-selected') { sel.value = o.value; break; }
        }
      }
      var ph = sel.querySelector('option[value="not-selected"]');
      if (ph) ph.remove();

      var productJson = null;
      function withProduct(cb) {
        if (productJson) { cb(productJson); return; }
        var url = vs.getAttribute('product-url'); // "{{ product.url }}.js"
        if (!url) return;
        window.fetch(url, { credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (p) { productJson = p; cb(p); })
          .catch(function () {});
      }

      var scope = vs.closest('[data-product-details], .product--outer') || document;

      function apply() {
        var id = parseInt(sel.value, 10);
        if (!id) return;
        withProduct(function (p) {
          var v = null;
          for (var i = 0; i < p.variants.length; i++) {
            if (p.variants[i].id === id) { v = p.variants[i]; break; }
          }
          if (!v) return;
          Array.prototype.forEach.call(scope.querySelectorAll('[data-price]'), function (el) {
            el.textContent = money(v.price);
          });
          var onSale = v.compare_at_price && v.compare_at_price > v.price;
          Array.prototype.forEach.call(scope.querySelectorAll('[data-price-compare-container]'), function (c) {
            c.classList.toggle('visible', !!onSale);
            var cmp = c.querySelector('[data-price-compare]');
            if (cmp && onSale) cmp.textContent = money(v.compare_at_price);
          });
          var atc = scope.querySelector('.product-form--atc-button, button[name="add"]');
          if (atc) {
            atc.disabled = !v.available;
            if (v.available) atc.removeAttribute('disabled');
          }
          try {
            var u = new URL(window.location.href);
            u.searchParams.set('variant', String(id));
            window.history.replaceState({}, '', u.pathname + u.search);
          } catch (e) {}
          var g = document.querySelector('product-gallery');
          if (g && typeof g.showVariantMedia === 'function' && v.featured_media) g.showVariantMedia(v);
          vs.setAttribute('variant', String(id));
          vs.dispatchEvent(new CustomEvent('fb:variant-change', { bubbles: true, detail: { variant: v } }));
        });
      }

      sel.addEventListener('change', apply);
    });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
